module.exports = __webpack_public_path__ + "static/media/PM33.0192e86c.png";